import { useMemo } from "react";
import { useQuery } from "react-query";

import { useUser } from "@/providers/context";
import { getStripeUser } from "@/api";
import { HOURS_12_IN_MS } from "@/const.ts";

export const useStripeUser = () => {
  const { uid } = useUser();
  const query = useQuery(["stripe", uid], () => getStripeUser(), {
    staleTime: HOURS_12_IN_MS, // 12 hours, this data does not change frequently
  });

  const activeSubscription = useMemo(() => {
    return query?.data?.Subscriptions.find((s) =>
      ["active", "trial", "past_due"].includes(s.Status),
    );
  }, [query.data]);

  return { ...query, activeSubscription };
};
